webpackJsonp([16],{

/***/ 147:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(582)

var Component = __webpack_require__(73)(
  /* script */
  __webpack_require__(307),
  /* template */
  __webpack_require__(595),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 148:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _jsCookie = __webpack_require__(146);

var _jsCookie2 = _interopRequireDefault(_jsCookie);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var domainMap = {"qukan":{"default":" http://logserver-api.qutoutiao.net/"},"perm":{"default":"http://api.perm.1sapp.com/"}};
var codeEvn = "production";
var projectName = "logserver";
var projectTitle = "通用日志上报服务平台";
var isProduction = codeEvn === 'production' || codeEvn === 'preview';

var branchMap = {};

var ApiDomain = function () {
    function ApiDomain() {
        _classCallCheck(this, ApiDomain);

        this.domains = this.getDomains();
    }

    _createClass(ApiDomain, [{
        key: 'getDomains',
        value: function getDomains() {
            var map = {};
            for (var i in domainMap) {
                var key = i + '_branch';
                var branch = _jsCookie2.default.get(key) || 'default';
                branchMap[i] = branch;
                map[i] = this.getBranch(i, branch);
            }
            return map;
        }
    }, {
        key: 'getBranch',
        value: function getBranch(type, branch) {
            var domain = domainMap[type];
            if (domain) {
                if (domain.hasOwnProperty(branch)) {
                    return domain[branch];
                } else {
                    console.error('\u4E0D\u5B58\u5728' + type + '\u5BF9\u5E94\u9879\u76EE' + branch + '\u5206\u652F');
                }
            } else {
                console.error('\u4E0D\u5B58\u5728' + type + '\u5BF9\u5E94\u9879\u76EE');
            }
        }
    }, {
        key: 'getUrl',
        value: function getUrl(api) {
            var domains = this.domains;
            var project = api.project,
                path = api.path;

            var domain = "";
            if (project in domains) {
                domain = domains[project];
            }
            if (!domain) throw new Error('ApiDomain.getUrl\uFF1A\u6CA1\u6709\u914D\u7F6E\u8BE5 ' + project + ' \u9879\u76EE\u7684 domain');
            if (/^\//.test(path)) {
                path = path.substring(1, path.length);
            } else {
                console.warn('路径需要以/开头！');
            }
            return '' + domain + path;
        }
    }, {
        key: 'getBranchMap',
        value: function getBranchMap() {
            return branchMap;
        }
    }, {
        key: 'isProduct',
        value: function isProduct() {
            return isProduction;
        }
    }, {
        key: 'getEvn',
        value: function getEvn() {
            return codeEvn;
        }
    }, {
        key: 'isDevelopment',
        value: function isDevelopment() {
            return !isProduction;
        }
    }, {
        key: 'getProject',
        value: function getProject() {
            return projectName;
        }
    }, {
        key: 'getProjectTitle',
        value: function getProjectTitle() {
            return projectTitle;
        }
    }], [{
        key: 'setApiBranch',
        value: function setApiBranch(query) {
            if (isProduction) {
                // 线上代码不保存高度cookie
                return;
            }
            for (var i in domainMap) {
                var key = '_' + i;
                if (query.hasOwnProperty(key)) {
                    var branch = query[key];
                    if (domainMap[i].hasOwnProperty(branch)) {
                        branchMap[i] = branch;
                        _jsCookie2.default.set(i + '_branch', branch);
                    }
                }
            }
        }
    }]);

    return ApiDomain;
}();

exports.default = ApiDomain;

/***/ }),

/***/ 149:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _app = __webpack_require__(315);

var _app2 = _interopRequireDefault(_app);

var _user = __webpack_require__(316);

var _user2 = _interopRequireDefault(_user);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// import global from './global';
var isHistoryApi = !!(window.history && history.pushState);

exports.default = {
    // todo
    mode: isHistoryApi ? 'history' : 'hash',
    linkActiveClass: 'is-active',
    scrollBehavior: function scrollBehavior() {
        return { y: 0 };
    },
    routes: [{
        path: '/login',
        component: __webpack_require__(232),
        meta: {
            label: '登录',
            hidden: true
        }
    },
    // {
    //     path: '/',
    //     component: require('../views/Home'),
    //     redirect: {
    //         name: 'TopicList'
    //     },
    //     meta: {
    //         label: '首页',
    //         hidden: true
    //     }
    // },
    // global,
    _app2.default, _user2.default, {
        path: '/',
        redirect: '/app/topic-list',
        meta: {
            hidden: true
        }
    }, {
        path: '*',
        redirect: '/404',
        meta: {
            hidden: true
        }
    }]
};

/***/ }),

/***/ 150:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

var _BaseRequest2 = __webpack_require__(312);

var _BaseRequest3 = _interopRequireDefault(_BaseRequest2);

var _Apis = __webpack_require__(311);

var _Apis2 = _interopRequireDefault(_Apis);

var _DataCenterLog = __webpack_require__(313);

var _DataCenterLog2 = _interopRequireDefault(_DataCenterLog);

var _ApiDomain = __webpack_require__(148);

var _ApiDomain2 = _interopRequireDefault(_ApiDomain);

var _ewxLoginSdk = __webpack_require__(65);

var _ewxLoginSdk2 = _interopRequireDefault(_ewxLoginSdk);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var QuRequest = function (_BaseRequest) {
    _inherits(QuRequest, _BaseRequest);

    function QuRequest() {
        _classCallCheck(this, QuRequest);

        var _this = _possibleConstructorReturn(this, (QuRequest.__proto__ || Object.getPrototypeOf(QuRequest)).call(this));

        _this.Apis = _Apis2.default;
        _this.apiDomain = new _ApiDomain2.default();
        return _this;
    }

    _createClass(QuRequest, [{
        key: 'getUrl',
        value: function getUrl(api) {
            return this.apiDomain.getUrl(api);
        }
    }, {
        key: 'nativeSend',
        value: function nativeSend(api) {
            var _this2 = this;

            var data = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

            data = Object.assign({
                token: _ewxLoginSdk2.default.getToken({ isPerm: true })
                // dtu: 200
            }, data);

            // if (api.project === 'perm') {
            //     data.project = 'perm';
            // }

            return _get(QuRequest.prototype.__proto__ || Object.getPrototypeOf(QuRequest.prototype), 'send', this).call(this, {
                url: api.url,
                type: api.type,
                timeout: api.timeout,
                headers: api.headers
            }, data).then(function (response) {
                return _this2.responseInterceptor(response, api);
            }, function (error) {
                _this2.errorInterceptor(error);
            });
        }
    }, {
        key: 'send',
        value: function send(api) {
            var data = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

            var url = this.apiDomain.getUrl(api);
            return this.nativeSend({
                url: url,
                type: api.type,
                timeout: api.timeout,
                headers: api.headers,
                author: api._author || '',
                project: api.project
            }, data);
        }
    }, {
        key: 'responseInterceptor',
        value: function responseInterceptor(response, api) {
            var res = response.data;
            // TODO
            var rules = {
                '0': function _(res) {
                    return res;
                },
                '3': function _(res) {
                    return res;
                },
                '-2101': function _() {
                    return res;
                },
                '-126': function _() {
                    // location.href='/#/login'
                }
            };
            if (rules[res.code]) {
                return rules[res.code](res);
            }
            // not define code throw error
            _DataCenterLog2.default.send({
                item: 2001,
                path: api.url,
                author: api.author,
                code: res.code,
                message: res.message
            });
            /* eslint-disable no-throw-literal */
            throw {
                msg: '\u8BF7\u6C42\u5931\u8D25code: ' + res.code + ', message: ' + (res.msg || '未知原因') + '\uFF0C\u63A5\u53E3\u5F00\u53D1\u8005\uFF1A' + api.author,
                stack: new Error().stack,
                code: res.code
            };
            /* eslint-enable no-throw-literal */
        }
    }, {
        key: 'errorInterceptor',
        value: function errorInterceptor(error) {
            var status = 0;
            if (error.response) {
                status = error.response.status;
            } else if (error.request) {
                status = error.request.status;
            }
            throw new Error('\u7F51\u7EDC\u9519\u8BEF [ ' + status + ' ] ' + error.message + ' ');
        }
    }, {
        key: 'getProject',
        value: function getProject() {
            return this.apiDomain.getProject();
        }
    }, {
        key: 'getBranch',
        value: function getBranch() {
            return this.apiDomain.getBranchMap();
        }
    }, {
        key: 'isProduct',
        value: function isProduct() {
            return this.apiDomain.isProduct();
        }
    }, {
        key: 'getProjectTitle',
        value: function getProjectTitle() {
            return this.apiDomain.getProjectTitle();
        }
    }]);

    return QuRequest;
}(_BaseRequest3.default);

exports.default = QuRequest;

/***/ }),

/***/ 164:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var ApiInfo = function () {
    function ApiInfo(_ref) {
        var path = _ref.path,
            _ref$type = _ref.type,
            type = _ref$type === undefined ? 'get' : _ref$type,
            _ref$timeout = _ref.timeout,
            timeout = _ref$timeout === undefined ? 5000 : _ref$timeout,
            _ref$headers = _ref.headers,
            headers = _ref$headers === undefined ? {} : _ref$headers,
            _ref$project = _ref.project,
            project = _ref$project === undefined ? 'qupost' : _ref$project,
            _ref$author = _ref.author,
            author = _ref$author === undefined ? '未定义' : _ref$author;

        _classCallCheck(this, ApiInfo);

        this._path = path;
        this._type = type;
        this._author = author;
        this.timeout = timeout;
        this.headers = headers;
        this.project = project;
    }

    _createClass(ApiInfo, [{
        key: 'path',
        get: function get() {
            return this._path;
        }
    }, {
        key: 'type',
        get: function get() {
            return this._type;
        }
    }, {
        key: 'author',
        get: function get() {
            return this._author;
        }
    }]);

    return ApiInfo;
}();

exports.default = ApiInfo;

/***/ }),

/***/ 165:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

// lazy loading Components
// https://github.com/vuejs/vue-router/blob/dev/examples/lazy-loading/app.js#L8
exports.default = function (name) {
  var index = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  return function () {
    return __webpack_require__(599)("./" + name + (index ? '/index' : '') + '.vue');
  };
};

/***/ }),

/***/ 232:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(581)

var Component = __webpack_require__(73)(
  /* script */
  __webpack_require__(308),
  /* template */
  __webpack_require__(594),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 233:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = {
    en: {},
    zn: {
        header: {
            title: "趣推吧后台"
        },
        sidebar: {
            "GlobalSettingType": "全局配置",
            "GlobalSetting": "全局配置",
            "Package": "包管理",
            "Version": "版本管理",
            "Cdn": "CDN",
            "Domain": "收徒域名管理",
            "Upload": "图片上传",
            "ContentManage": "内容管理",
            "NetworkArticleAudit": "网络图文审核",
            "NetworkArticleAuditDetail": "网络图文详情",
            "NetworkMediaAudit": "网络视频审核",
            "NetworkMediaAuditDetail": "网络视频详情",
            "PushContentManage": "线上内容管理",
            "PushContentEdit": "线上内容编辑",
            "Comment": "评论安全巡查",
            "ArticlePush": "文章推送管理",
            "ArticlePushEdit": "文章推送编辑",
            "OperationManage": "用户管理",
            "User": "用户管理",
            "Tool": "工具",
            "PushMessage": "系统消息",
            "FinanceManage": "财务管理",
            "ToReview": "提现审核",
            "RateChange": "汇率调整",
            "taskManage": "任务管理"
        }
    }
};

/***/ }),

/***/ 234:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _vue = __webpack_require__(19);

var _vue2 = _interopRequireDefault(_vue);

var _vuex = __webpack_require__(244);

var _vuex2 = _interopRequireDefault(_vuex);

var _app = __webpack_require__(317);

var _app2 = _interopRequireDefault(_app);

var _user = __webpack_require__(318);

var _user2 = _interopRequireDefault(_user);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

_vue2.default.use(_vuex2.default);

exports.default = new _vuex2.default.Store({
    modules: {
        app: _app2.default,
        user: _user2.default
    }
});

/***/ }),

/***/ 237:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 238:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 239:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 241:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(584)

var Component = __webpack_require__(73)(
  /* script */
  __webpack_require__(306),
  /* template */
  __webpack_require__(597),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 245:
/***/ (function(module, exports) {

module.exports = {"LOGIN_URL":"https://permission.1sapp.com","PROJECT_SCHEMA":"ewx-project","TOKEN_SCHEMA":"ewx-perm-token","QA_SCHEMA":"ewx-qa","TOKEN_EXPIRES":100,"API_URL":"https://api-perm.1sapp.com","TEST_API_URL":"http://test-api.qukan.perm.aimodou.net"}

/***/ }),

/***/ 305:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
//
//
//
//

exports.default = {
  name: 'nprogress-container'
};

/***/ }),

/***/ 306:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _NprogressContainer = __webpack_require__(593);

var _NprogressContainer2 = _interopRequireDefault(_NprogressContainer);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    name: 'app',
    components: {
        NprogressContainer: _NprogressContainer2.default
    }
}; //
//
//
//
//
//
//
//
//
//

/***/ }),

/***/ 307:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _QuRequest = __webpack_require__(150);

var _QuRequest2 = _interopRequireDefault(_QuRequest);

var _index = __webpack_require__(149);

var _index2 = _interopRequireDefault(_index);

var _ewxLoginSdk = __webpack_require__(65);

var _ewxLoginSdk2 = _interopRequireDefault(_ewxLoginSdk);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; } //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// import util from '../common/js/util';


var quRequest = new _QuRequest2.default();

exports.default = {
    data: function data() {
        return {
            appList: [],
            appId: 'qtt',
            isCollapse: true,
            info: {},
            title: quRequest.getProjectTitle(),
            // menu: util.checkPermApi(routerMap.routes),
            menu: _index2.default.routes,
            disabled: true,
            isProduct: quRequest.isProduct(),
            branchMap: quRequest.getBranch(),
            apiBranch: '',
            token: _ewxLoginSdk2.default.getToken({ isPerm: true })
        };
    },

    methods: {
        getUserRoleList: function getUserRoleList() {
            var _this = this;

            quRequest.send(quRequest.Apis.qukan.api.loginNew, {
                token: _ewxLoginSdk2.default.getToken({ isPerm: true })
            }).then(function (res) {
                if (res.code === 0) {
                    //  "viewer" - 可读-阅览者
                    // "editor" - 可读可写-开发者
                    // "admin" - 可读可写-管理员
                    _this.$store.commit('m:user/role', res.data.role);
                    // localStorage.setItem('role', res.data.role);
                    // 获取app列表
                    _this.getAppList();
                } else {
                    _this.$message({
                        type: 'error',
                        message: res.msg
                    });
                }
            }, function (rej) {
                _this.$message({
                    type: 'error',
                    message: rej.msg
                });
            });
        },
        getAppList: function getAppList() {
            var _this2 = this;

            quRequest.send(quRequest.Apis.qukan.api.getAppList, null).then(function (res) {
                _this2.appList = res.data;
                // window.localStorage.setItem('app_id', this.appId);
                _this2.$store.commit('m:app/appId', _this2.appId);
                _this2.$store.commit('m:app/appList', _this2.appList);
                if (_this2.$route.path === '/app/topic-list') {
                    _this2.$router.push({ path: _this2.$route.path, query: { app_id: _this2.appId } });
                }
            }, function (rej) {
                _this2.$message({
                    type: 'error',
                    message: rej.msg
                });
            });
        },

        // getAppName (id) {
        //     for (let item of this.appList) {
        //         if (item.app_id === id) {
        //             window.sessionStorage.setItem('app_info', JSON.stringify(item));
        //             break;
        //         }
        //     }
        // },
        getMemberInfo: function getMemberInfo() {
            var _this3 = this;

            return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
                return regeneratorRuntime.wrap(function _callee$(_context) {
                    while (1) {
                        switch (_context.prev = _context.next) {
                            case 0:
                                _context.prev = 0;
                                _context.next = 3;
                                return _ewxLoginSdk2.default.getUserInfo({ isPerm: true });

                            case 3:
                                _context.t0 = _context.sent;

                                if (_context.t0) {
                                    _context.next = 6;
                                    break;
                                }

                                _context.t0 = {};

                            case 6:
                                _this3.info = _context.t0;
                                _context.next = 12;
                                break;

                            case 9:
                                _context.prev = 9;
                                _context.t1 = _context['catch'](0);

                                _this3.$message.error('' + (_context.t1.message || '未知错误'));

                            case 12:
                                _this3.loading = false;

                            case 13:
                            case 'end':
                                return _context.stop();
                        }
                    }
                }, _callee, _this3, [[0, 9]]);
            }))();
        },
        handleOpen: function handleOpen() {},
        handleClose: function handleClose() {},

        // 退出登录
        logout: function logout() {
            var _this4 = this;

            this.$confirm('确认退出吗?', '提示', {}).then(function () {
                localStorage.clear();
                _ewxLoginSdk2.default.logout({ isPerm: true }).then(function (res) {
                    _this4.$router.push('/login');
                });
            });
        },

        // 折叠导航栏
        collapse: function collapse() {
            this.isCollapse = !this.isCollapse;
        }
    },
    watch: {
        appId: function appId(val) {
            // window.localStorage.setItem('app_id', this.appId);
            this.$store.commit('m:app/appId', this.appId);
            this.$router.push({ path: this.$route.path, query: { app_id: this.appId } });
        }
    },
    mounted: function mounted() {
        // if (this.branchMap && this.branchMap.qukan) {
        //     this.apiBranch = this.branchMap.qukan;
        // }
        // 获取鉴权用户信息
        this.getMemberInfo();
        // 获取用户角色列表
        this.getUserRoleList();
    }
};

/***/ }),

/***/ 308:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _ewxLoginSdk = __webpack_require__(65);

var _ewxLoginSdk2 = _interopRequireDefault(_ewxLoginSdk);

var _QuRequest = __webpack_require__(150);

var _QuRequest2 = _interopRequireDefault(_QuRequest);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

//
//
//
//
//

var quRequest = new _QuRequest2.default();

exports.default = {
    beforeRouteEnter: function beforeRouteEnter(to, from, next) {
        var login = function login() {
            // the project author
            var copyright = {
                guardian: '韩玲',
                team: {
                    name: '',
                    link: ''
                },
                feedback: ''
            };
            _ewxLoginSdk2.default.login({
                project: quRequest.getProject(),
                url: location.href,
                qa: !quRequest.isProduct(),
                copyright: JSON.stringify(copyright)
            });
        };
        _ewxLoginSdk2.default.getUserInfo({ isPerm: true }).then(function (res) {
            if (!res) {
                login();
            } else {
                location.href = '/';
            }
        }, function (rej) {
            login();
        });
    }
};

/***/ }),

/***/ 309:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _ApiInfo2 = __webpack_require__(164);

var _ApiInfo3 = _interopRequireDefault(_ApiInfo2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var QuKanPermApiInfo = function (_ApiInfo) {
    _inherits(QuKanPermApiInfo, _ApiInfo);

    function QuKanPermApiInfo(_ref) {
        var path = _ref.path,
            _ref$type = _ref.type,
            type = _ref$type === undefined ? 'get' : _ref$type,
            _ref$timeout = _ref.timeout,
            timeout = _ref$timeout === undefined ? 5000 : _ref$timeout,
            headers = _ref.headers,
            _ref$project = _ref.project,
            project = _ref$project === undefined ? 'perm' : _ref$project,
            _ref$author = _ref.author,
            author = _ref$author === undefined ? '未定义' : _ref$author;

        _classCallCheck(this, QuKanPermApiInfo);

        return _possibleConstructorReturn(this, (QuKanPermApiInfo.__proto__ || Object.getPrototypeOf(QuKanPermApiInfo)).call(this, {
            path: path,
            type: type,
            timeout: timeout,
            headers: headers,
            project: project,
            author: author
        }));
    }

    return QuKanPermApiInfo;
}(_ApiInfo3.default);

exports.default = {
    member: {
        list: new QuKanPermApiInfo({
            path: '/member/list',
            type: 'get',
            author: '刘彪'
        }),
        getMember: new QuKanPermApiInfo({
            path: '/member/getMember',
            type: 'get',
            author: '刘彪'
        }),
        allowLogin: new QuKanPermApiInfo({
            path: '/member/allowLogin',
            type: 'post',
            author: '刘彪'
        }),
        login: new QuKanPermApiInfo({
            path: '/member/login',
            type: 'get',
            author: '刘彪'
        }),
        loginByPwd: new QuKanPermApiInfo({
            path: '/member/loginByPwd',
            type: 'get',
            author: '刘彪'
        }),
        checkPerm: new QuKanPermApiInfo({
            path: '/member/checkPerm',
            type: 'post',
            author: '刘彪'
        })
    },
    perm: {
        list: new QuKanPermApiInfo({
            path: '/perm/getPermGroupList',
            type: 'post',
            author: '刘彪'
        })

    }
};

/***/ }),

/***/ 310:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _ApiInfo2 = __webpack_require__(164);

var _ApiInfo3 = _interopRequireDefault(_ApiInfo2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var QukanApiInfo = function (_ApiInfo) {
    _inherits(QukanApiInfo, _ApiInfo);

    // 声明接口类
    function QukanApiInfo(_ref) {
        var path = _ref.path,
            _ref$type = _ref.type,
            type = _ref$type === undefined ? 'get' : _ref$type,
            _ref$timeout = _ref.timeout,
            timeout = _ref$timeout === undefined ? 5000 : _ref$timeout,
            headers = _ref.headers,
            _ref$project = _ref.project,
            project = _ref$project === undefined ? 'qukan' : _ref$project,
            _ref$author = _ref.author,
            author = _ref$author === undefined ? '未定义' : _ref$author;

        _classCallCheck(this, QukanApiInfo);

        return _possibleConstructorReturn(this, (QukanApiInfo.__proto__ || Object.getPrototypeOf(QukanApiInfo)).call(this, {
            path: path,
            type: type,
            timeout: timeout,
            headers: headers,
            project: project,
            author: author
        }));
    }

    return QukanApiInfo;
}(_ApiInfo3.default);

exports.default = {
    api: {
        login: new QukanApiInfo({
            path: '/api/login',
            type: 'post',
            author: '张颢'
        }),
        loginNew: new QukanApiInfo({
            path: '/api/login_new',
            type: 'post',
            author: '张颢'
        }),
        getAppList: new QukanApiInfo({
            // 声明接口对象
            path: '/api/app',
            type: 'get',
            author: '张颢'
        }),
        getTopicList: new QukanApiInfo({
            // 声明接口对象
            path: '/api/topic',
            type: 'get',
            author: '张颢'
        }),
        getCmdRangeList: new QukanApiInfo({
            // 声明接口对象
            path: '/api/cmd_range',
            type: 'get',
            author: '张颢'
        }),
        getTopicCmdList: new QukanApiInfo({
            // 声明接口对象
            path: '/api/topic_cmd',
            type: 'get',
            author: '张颢'
        }),
        getOutCmdList: new QukanApiInfo({
            // 声明接口对象
            path: '/api/topic_out_cmd',
            type: 'get',
            author: '张颢'
        }),
        getCmdList: new QukanApiInfo({
            // 声明接口对象
            path: '/api/cmd',
            type: 'get',
            author: '张颢'
        }),
        addTopicCmd: new QukanApiInfo({
            path: '/api/add_topic_cmd',
            type: 'post',
            author: '张颢'
        }),
        addCmd: new QukanApiInfo({
            path: '/api/add_cmd',
            type: 'post',
            author: '张颢'
        }),
        delCmd: new QukanApiInfo({
            path: '/api/del_cmd',
            type: 'post',
            author: '张颢'
        }),
        modCmd: new QukanApiInfo({
            path: '/api/mod_cmd',
            type: 'post',
            author: '张颢'
        }),
        getActionMetricList: new QukanApiInfo({
            path: '/api/cmd_detail_new',
            type: 'get',
            author: '张颢'
        }),
        getCmdDetailList: new QukanApiInfo({
            path: '/api/cmd_detail',
            type: 'get',
            author: '张颢'
        }),
        getCmdDetailMetricKeyList: new QukanApiInfo({
            path: '/api/cmd_detail_metric_key',
            type: 'get',
            author: '张颢'
        }),
        addCmdMetric: new QukanApiInfo({
            path: '/api/add_cmd_metric',
            type: 'post',
            author: '张颢'
        }),
        modCmdMetric: new QukanApiInfo({
            path: '/api/mod_cmd_metric',
            type: 'post',
            author: '张颢'
        }),
        delCmdMetric: new QukanApiInfo({
            path: '/api/del_cmd_metric',
            type: 'post',
            author: '张颢'
        }),
        addCmdDetail: new QukanApiInfo({
            path: '/api/add_cmd_key',
            type: 'post',
            author: '张颢'
        }),
        delCmdDetail: new QukanApiInfo({
            path: '/api/del_cmd_key',
            type: 'post',
            author: '张颢'
        }),
        modCmdDetail: new QukanApiInfo({
            path: '/api/mod_cmd_key',
            type: 'post',
            author: '张颢'
        }),
        addCmdMetricKey: new QukanApiInfo({
            path: '/api/add_cmd_metric_key',
            type: 'post',
            author: '张颢'
        }),
        delCmdMetricKey: new QukanApiInfo({
            path: '/api/del_cmd_metric_key',
            type: 'post',
            author: '张颢'
        }),
        modCmdMetricKey: new QukanApiInfo({
            path: '/api/mod_cmd_metric_key',
            type: 'post',
            author: '张颢'
        }),
        getApproveList: new QukanApiInfo({
            path: '/api/apply',
            type: 'get',
            author: '张颢'
        }),
        approveApply: new QukanApiInfo({
            path: '/api/approve',
            type: 'post',
            author: '张颢'
        }),
        getUserList: new QukanApiInfo({
            path: '/api/role',
            type: 'get',
            author: '张颢'
        }),
        modRole: new QukanApiInfo({
            path: '/api/mod_role',
            type: 'post',
            author: '张颢'
        })
    }
};

/***/ }),

/***/ 311:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _Qukan = __webpack_require__(310);

var _Qukan2 = _interopRequireDefault(_Qukan);

var _Perm = __webpack_require__(309);

var _Perm2 = _interopRequireDefault(_Perm);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    qukan: _Qukan2.default,
    perm: _Perm2.default
};

/***/ }),

/***/ 312:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }(); // @ts-check


var _axios = __webpack_require__(286);

var _axios2 = _interopRequireDefault(_axios);

var _q = __webpack_require__(588);

var _q2 = _interopRequireDefault(_q);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

// import qs from 'qs'

_axios2.default.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded; charset=UTF-8';
_axios2.default.defaults.withCredentials = true;
// axios.defaults.headers.post['withCredentials'] = 'true'

var BaseRequest = function () {
    function BaseRequest() {
        _classCallCheck(this, BaseRequest);
    }

    _createClass(BaseRequest, [{
        key: 'send',

        // constructor () {}

        value: function send(_ref) {
            var url = _ref.url,
                _ref$type = _ref.type,
                type = _ref$type === undefined ? 'get' : _ref$type,
                _ref$timeout = _ref.timeout,
                timeout = _ref$timeout === undefined ? 10000 : _ref$timeout,
                _ref$headers = _ref.headers,
                headers = _ref$headers === undefined ? {} : _ref$headers;
            var body = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

            var options = {
                url: url,
                method: type.toLocaleLowerCase(),
                timeout: timeout,
                headers: headers
                // withCredentials: true
            };

            try {
                // 处理 post 参数格式
                if (options.method === 'post') {
                    // qs将请求数据转换为form-data格式
                    // options.data = qs.stringify(body)
                    // 请求数据json格式
                    options.data = body;
                } else if (options.method === 'get') {
                    options.params = body;
                } else {
                    options.data = body;
                }
                return _q2.default.resolve((0, _axios2.default)(options));
            } catch (e) {
                _q2.default.reject(e);
            }
        }
    }]);

    return BaseRequest;
}();

exports.default = BaseRequest;

/***/ }),

/***/ 313:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var DataCenterLog = function () {
    function DataCenterLog() {
        _classCallCheck(this, DataCenterLog);
    }

    _createClass(DataCenterLog, null, [{
        key: 'send',
        value: function send(_ref) {
            var _ref$cmd = _ref.cmd,
                cmd = _ref$cmd === undefined ? 9010 : _ref$cmd,
                _ref$item = _ref.item,
                item = _ref$item === undefined ? '' : _ref$item,
                _ref$action = _ref.action,
                action = _ref$action === undefined ? '' : _ref$action,
                _ref$page_id = _ref.page_id,
                page_id = _ref$page_id === undefined ? '' : _ref$page_id,
                _ref$pos = _ref.pos,
                pos = _ref$pos === undefined ? '' : _ref$pos,
                _ref$uid = _ref.uid,
                uid = _ref$uid === undefined ? '' : _ref$uid;

            var path = 'http://log.1sapp.com/a.gif?';
            var query = [];
            var arg = arguments[0] || {};
            var option = _extends({
                cmd: cmd, item: item, action: action, page_id: page_id, pos: pos, uid: uid }, arg);
            for (var key in option) {
                query.push(key + '=' + option[key]);
            }
            // new Image().src = path + query.join('&');
        }
    }]);

    return DataCenterLog;
}();

exports.default = DataCenterLog;

/***/ }),

/***/ 314:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _babelPolyfill = __webpack_require__(235);

var _babelPolyfill2 = _interopRequireDefault(_babelPolyfill);

__webpack_require__(238);

var _vue = __webpack_require__(19);

var _vue2 = _interopRequireDefault(_vue);

var _vueNprogress = __webpack_require__(242);

var _vueNprogress2 = _interopRequireDefault(_vueNprogress);

var _vueRouter = __webpack_require__(243);

var _vueRouter2 = _interopRequireDefault(_vueRouter);

var _vueI18n = __webpack_require__(240);

var _vueI18n2 = _interopRequireDefault(_vueI18n);

var _App = __webpack_require__(241);

var _App2 = _interopRequireDefault(_App);

var _elementUi = __webpack_require__(236);

var _elementUi2 = _interopRequireDefault(_elementUi);

__webpack_require__(239);

var _index = __webpack_require__(149);

var _index2 = _interopRequireDefault(_index);

var _lang = __webpack_require__(233);

var _lang2 = _interopRequireDefault(_lang);

__webpack_require__(237);

var _ApiDomain = __webpack_require__(148);

var _ApiDomain2 = _interopRequireDefault(_ApiDomain);

var _ewxLoginSdk = __webpack_require__(65);

var _ewxLoginSdk2 = _interopRequireDefault(_ewxLoginSdk);

var _store = __webpack_require__(234);

var _store2 = _interopRequireDefault(_store);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* eslint-enable no-unused-vars */
_vue2.default.use(_elementUi2.default);
// import 'element-ui/lib/theme-chalk/index.css';
/* eslint-disable no-unused-vars */

_vue2.default.use(_vueRouter2.default);
_vue2.default.use(_vueI18n2.default);
_vue2.default.use(_vueNprogress2.default);

var nprogress = new _vueNprogress2.default({
    parent: '.nprogress-container'
});

var i18n = new _vueI18n2.default({
    locale: 'zn', // set locale
    messages: _lang2.default // set locale messages
});

var router = new _vueRouter2.default(_index2.default);

router.beforeEach(function (to, from, next) {
    // 测试接口切换功能
    _ApiDomain2.default.setApiBranch(to.query);
    if (to.fullPath === '/login' || from.fullPath === '/login') {
        next();
    } else {
        _ewxLoginSdk2.default.getUserInfo({ isPerm: true }).then(function (res) {
            if (!res) {
                next('/login');
            } else {
                next();
            }
        });
    }
});

_vue2.default.mixin({
    created: function created() {
        if (this.filter) {
            this.filter = this.$queryFilter();
            this.$updateRouter(this.filter);
        }
    },

    methods: {
        $queryFilter: function $queryFilter() {
            var filter = this.filter || {};
            if (this.$route) {
                var query = this.$route.query;
                for (var i in filter) {
                    if (typeof query[i] !== 'undefined') {
                        if (typeof filter[i] === 'number') {
                            filter[i] = parseInt(query[i]);
                        } else {
                            filter[i] = query[i];
                        }
                    }
                }
            }
            return filter;
        },
        $updateRouter: function $updateRouter(query) {
            if (!query) {
                query = this.$queryFilter();
            }
            this.$router.replace({
                query: Object.assign({}, query)
            });
        },
        $blockRequest: function $blockRequest(_ref) {
            var $elem = _ref.$elem,
                req = _ref.req,
                _ref$pendingText = _ref.pendingText,
                pendingText = _ref$pendingText === undefined ? '操作中' : _ref$pendingText;

            if (!$elem) {
                $elem = document.createElement('button');
            }
            if (!$elem || $elem._req_block) return;

            var isButton = $elem.nodeName.toLowerCase() === 'button';
            var oText = $elem.innerText;

            if (isButton) $elem.setAttribute('disabled', true);

            $elem.innerText = pendingText;
            $elem._req_block = true;

            return req.fin(function () {
                if (isButton) $elem.removeAttribute('disabled');
                $elem._req_block = false;
                $elem.innerText = oText;
            });
        }
    }
});

new _vue2.default({
    router: router,
    store: _store2.default,
    i18n: i18n,
    nprogress: nprogress,
    render: function render(h) {
        return h(_App2.default);
    }
}).$mount('#app');

/***/ }),

/***/ 315:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _lazyLoading = __webpack_require__(165);

var _lazyLoading2 = _interopRequireDefault(_lazyLoading);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    path: '/app',
    meta: {
        icon: 'el-icon-setting',
        label: '配置管理',
        hidden: false
    },
    component: __webpack_require__(147),
    children: [{
        name: 'TopicList',
        path: 'topic-list',
        component: (0, _lazyLoading2.default)('app/TopicList'), // 加载模块
        meta: {
            label: 'Topic管理',
            hidden: false,
            api: [
                // 权限验证
                // Apis.qukan.config.list
            ]
        }
    }, {
        name: 'TopicCmdList',
        path: 'topic-cmd-list',
        component: (0, _lazyLoading2.default)('app/TopicCmdList'), // 加载模块
        meta: {
            label: 'Topic包含CMD列表',
            hidden: true
        }
    }, {
        name: 'RangeList',
        path: 'cmd-range-list',
        component: (0, _lazyLoading2.default)('app/CmdRangeList'), // 加载模块
        meta: {
            label: 'CMD管理',
            hidden: true,
            api: [
                // 权限验证
                // Apis.qukan.config.list
            ]
        }
    }, {
        name: 'CmdList',
        path: 'cmd-list',
        component: (0, _lazyLoading2.default)('app/CmdList'), // 加载模块
        meta: {
            label: 'CMD列表',
            hidden: true
        }
    }, {
        name: 'ActionMetricList',
        path: 'action-metric-list',
        component: (0, _lazyLoading2.default)('app/ActionMetricList'), // 加载模块
        meta: {
            label: 'actionmetric列表',
            hidden: true
        }
    }, {
        name: 'CmdDetailList',
        path: 'cmd-detail-list',
        component: (0, _lazyLoading2.default)('app/CmdDetailList'), // 加载模块
        meta: {
            label: 'cmddetail列表',
            hidden: true
        }
        // {
        //     name: 'Approve',
        //     path: 'approve-list',
        //     component: lazyLoading('approve/ApproveList'), // 审批列表
        //     meta: {
        //         label: '审批列表',
        //         hidden: false
        //     }
        // }
    }]
};

/***/ }),

/***/ 316:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _lazyLoading = __webpack_require__(165);

var _lazyLoading2 = _interopRequireDefault(_lazyLoading);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    path: '/app',
    meta: {
        icon: 'el-icon-setting',
        label: '权限管理',
        hidden: false
    },
    component: __webpack_require__(147),
    children: [{
        name: 'userList',
        path: 'user-list',
        component: (0, _lazyLoading2.default)('user/UserRoleList'), // 加载模块
        meta: {
            label: '权限管理',
            hidden: false,
            api: [
                // 权限验证
                // Apis.qukan.config.list
            ]
        }
    }]
};

/***/ }),

/***/ 317:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
var state = {
    appId: '',
    appList: []
};
var mutations = {
    'm:app/appId': function mAppAppId(state, id) {
        state.appId = id;
    },
    'm:app/appList': function mAppAppList(state, list) {
        state.appList = list;
    }
};
var actions = {};
exports.default = {
    state: state,
    mutations: mutations,
    actions: actions
};

/***/ }),

/***/ 318:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
var state = {
    role: ''
};
var mutations = {
    'm:user/role': function mUserRole(state, role) {
        state.role = role;
    }
};
var actions = {};
exports.default = {
    state: state,
    mutations: mutations,
    actions: actions
};

/***/ }),

/***/ 581:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 582:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 583:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 584:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 593:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(583)

var Component = __webpack_require__(73)(
  /* script */
  __webpack_require__(305),
  /* template */
  __webpack_require__(596),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 594:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content has-text-centered"
  })
},staticRenderFns: []}

/***/ }),

/***/ 595:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-row', {
    staticClass: "container"
  }, [_c('el-col', {
    staticClass: "header",
    attrs: {
      "span": 24
    }
  }, [_c('el-col', {
    staticClass: "logo",
    class: !_vm.isCollapse ? 'logo-collapse-width' : 'logo-width',
    attrs: {
      "span": 10
    },
    domProps: {
      "textContent": _vm._s(_vm.title)
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.isProduct && _vm.apiBranch.length > 0),
      expression: "!isProduct && apiBranch.length > 0"
    }],
    staticClass: "api-branch",
    domProps: {
      "textContent": _vm._s(_vm.apiBranch)
    }
  })]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 4
    }
  }, [_c('div', {
    staticClass: "tools",
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.collapse($event)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-align-justify"
  })])]), _vm._v(" "), _c('el-col', {
    staticClass: "userinfo",
    attrs: {
      "span": 10
    }
  }, [_c('span', [_vm._v("产品 :")]), _vm._v(" "), _c('div', {
    staticClass: "product-select"
  }, [_c('el-select', {
    attrs: {
      "placeholder": "请选择App"
    },
    model: {
      value: (_vm.appId),
      callback: function($$v) {
        _vm.appId = (typeof $$v === 'string' ? $$v.trim() : $$v)
      },
      expression: "appId"
    }
  }, _vm._l((_vm.appList), function(item) {
    return _c('el-option', {
      key: item.app_id,
      attrs: {
        "label": item.desc,
        "value": item.app_id
      }
    })
  }))], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.info.name),
      expression: "info.name"
    }],
    staticClass: "user-info"
  }, [_c('span', {
    staticClass: "nickname"
  }, [_vm._v(_vm._s(_vm.info.name))]), _vm._v(" "), _c('span', {
    staticClass: "logout",
    on: {
      "click": function($event) {
        _vm.logout()
      }
    }
  }, [_vm._v("退出")])])])], 1), _vm._v(" "), _c('el-col', {
    staticClass: "main",
    attrs: {
      "span": 24
    }
  }, [_c('div', {
    staticClass: "menu-box",
    class: _vm.isCollapse ? 'auto-width' : ''
  }, [_c('el-menu', {
    staticClass: "el-menu-vertical-demo",
    attrs: {
      "default-active": _vm.$route.path,
      "router": "",
      "collapse": !_vm.isCollapse
    },
    on: {
      "open": _vm.handleOpen,
      "close": _vm.handleClose
    }
  }, [_vm._l((_vm.menu), function(item, index) {
    return (!item.meta.hidden) ? [(item.children) ? _c('el-submenu', {
      key: index,
      attrs: {
        "index": item.path
      }
    }, [_c('template', {
      slot: "title"
    }, [_c('i', {
      class: item.meta.icon
    }), _vm._v(" "), _c('span', {
      attrs: {
        "slot": "title"
      },
      slot: "title"
    }, [_vm._v(_vm._s(item.meta.label))])]), _vm._v(" "), _vm._l((item.children), function(child) {
      return (!child.meta.hidden) ? _c('el-menu-item', {
        key: child.path,
        attrs: {
          "index": item.path + '/' + child.path
        }
      }, [_vm._v("\n                            " + _vm._s(child.meta.label) + "\n                        ")]) : _vm._e()
    })], 2) : _c('el-menu-item', {
      key: index,
      attrs: {
        "index": item.path,
        "disabled": ""
      }
    }, [_c('i', {
      class: item.meta.icon
    }), _vm._v(" "), _c('span', {
      attrs: {
        "slot": "title"
      },
      slot: "title"
    }, [_vm._v(_vm._s(item.meta.label))])])] : _vm._e()
  })], 2)], 1), _vm._v(" "), _c('section', {
    staticClass: "content-container"
  }, [_c('div', {
    staticClass: "grid-content bg-purple-light"
  }, [_c('el-col', {
    staticClass: "breadcrumb-container",
    attrs: {
      "span": 24
    }
  }, [_c('strong', {
    staticClass: "title"
  }, [_vm._v(_vm._s(_vm.$route.meta.label))]), _vm._v(" "), _c('el-breadcrumb', {
    staticClass: "breadcrumb-inner",
    attrs: {
      "separator": "/"
    }
  }, _vm._l((_vm.$route.matched), function(item) {
    return _c('el-breadcrumb-item', {
      key: item.path
    }, [_vm._v("\n                            " + _vm._s(item.meta.label) + "\n                        ")])
  }))], 1), _vm._v(" "), _c('el-col', {
    staticClass: "content-wrapper",
    attrs: {
      "span": 24
    }
  }, [_c('transition', {
    attrs: {
      "name": "fade",
      "mode": "out-in"
    }
  }, [_c('router-view')], 1)], 1)], 1)])])], 1)
},staticRenderFns: []}

/***/ }),

/***/ 596:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "nprogress-container"
  })
},staticRenderFns: []}

/***/ }),

/***/ 597:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [_c('nprogress-container'), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "fade",
      "mode": "out-in"
    }
  }, [_c('router-view')], 1)], 1)
},staticRenderFns: []}

/***/ }),

/***/ 599:
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./404.vue": [
		605,
		13
	],
	"./Home.vue": [
		147
	],
	"./Login.vue": [
		232
	],
	"./Login2.vue": [
		606,
		4
	],
	"./app/ActionMetricList.vue": [
		607,
		3
	],
	"./app/CmdDetailList.vue": [
		608,
		6
	],
	"./app/CmdList.vue": [
		609,
		12
	],
	"./app/CmdRangeList.vue": [
		610,
		11
	],
	"./app/TopicCmdList.vue": [
		611,
		5
	],
	"./app/TopicList.vue": [
		612,
		2
	],
	"./approve/ApproveList.vue": [
		613,
		1
	],
	"./global/EditCode.vue": [
		602,
		10
	],
	"./global/EditHistory.vue": [
		603,
		9
	],
	"./global/GlobalDialog.vue": [
		604,
		14
	],
	"./global/GlobalSetting.vue": [
		614,
		0
	],
	"./global/InputDomain.vue": [
		615,
		8
	],
	"./user/UserRoleList.vue": [
		616,
		7
	]
};
function webpackAsyncContext(req) {
	var ids = map[req];
	if(!ids)
		return Promise.reject(new Error("Cannot find module '" + req + "'."));
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		return __webpack_require__(ids[0]);
	});
};
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
module.exports = webpackAsyncContext;
webpackAsyncContext.id = 599;

/***/ })

},[314]);


// WEBPACK FOOTER //
// static/js/app.11bce3cad773094a781d.js